import React, { useRef, useEffect, useState } from "react";
import { Search,ChevronDown } from "lucide-react";
import { useSelector, useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { selectModuleTabs } from "../../../redux/selectors/tabsSelectors";
import { addTab, removeTab, setActiveTab, updateAppointmentTab } from "../../../redux/slices/appointmentsSlices";
import CalenderSettings from "./TabContent/Calendar-Main/CalendarSettings";

// UI & utility imports
import FilterButton from "../../../components/ACS-Dashboard/ACS-Blocks/FilterButton";
import Button from "../../../components/ACS-Dashboard/ACS-Blocks/Button";
import Tabs from "../../../components/ACS-Dashboard/ACS-Blocks/Tabs";

// Tab components
import MyAppointments from "./TabContent/MyAppointments";
import AppointmentsRequest from "./TabContent/Request";
import DraftAppointment from "./TabContent/Drafts";
import AppointmentForm from "./TabContent/Appointment-View/AppointmentForm";
import BulkSelectionModal from "./Modal/BulkSelection";
import axios from "axios";
import Cookies from "js-cookie";
import { fetchAppointmentById } from "./TabContent/api/AppointmentsApi";


const AppointmentDetails = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const [isBulkModalOpen, setIsBulkModalOpen] = useState(false); 
  const { tabs, activeTab, defaultTabsCount } = useSelector(
    selectModuleTabs("appointments")
  );
  const [allowedTabs, setAllowedTabs] = useState([]);
  const [userType, setUserType] = useState(null);

  // Check for URL parameter to automatically create appointment
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const shouldCreateAppointment = searchParams.get('createAppointment');
    const appointmentData = location.state?.appointmentData;

    if (shouldCreateAppointment === 'true') {
      
      navigate(location.pathname, { replace: true });
     
      handleCreateAppointment(appointmentData);
    }
  }, [location.search, navigate, location.pathname, location.state]);

  const handleOpenSettingsTab = () => {
    const existingTab = tabs.find((tab) => tab.id === "Settings");

    if (!existingTab) {
      dispatch(addTab({
        id: "Settings",
        name: "Settings",
        contentType: "settings",
        isDynamic: true,
        createdAt: Date.now(),
      }));
      dispatch(setActiveTab({ index: tabs.length }));
    } else {
      const index = tabs.findIndex((tab) => tab.id === "Settings");
      dispatch(setActiveTab({ index }));
    }
  };
  useEffect(() => {
    const fetchPrivileges = async () => {
      try {
        const token = Cookies.get("authToken");
        const res = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/auth/user/getPrivilegesByType`,
          {
            headers: { Authorization: `Bearer ${token}` },
            params: { privilegeType: "UI" },
          }
        );

        const privileges = res.data;
        

        // Get allowed tab keys (menu.name values)
        const tabs = privileges.map((p) => p.menu?.name?.toLowerCase()).filter(Boolean);
        setAllowedTabs(tabs);

        // Detect user type from action field
        if (privileges.some((p) => p.action?.toLowerCase().includes("carrierview"))) {
          setUserType("Carrier");
        } else if (privileges.some((p) => p.action?.toLowerCase().includes("shipperview"))) {
          setUserType("Shipper");
        }
      } catch (error) {
        console.error("Failed to fetch privileges:", error);
      }
    };

    fetchPrivileges();
  }, []);

  const [totalappointments, setTotalappointments] = useState(0); // ✅ Corrected casing
  const [searchQuery, setSearchQuery] = useState("");
  const [searchTrigger, setSearchTrigger] = useState(false);
  const [filter, setFilter] = useState(null);
  const tabVariants = tabs.map((tab) =>
    tab.contentType === "viewAppointment" &&
    (tab.appointmentData?.cancelled ||
      tab.appointmentData?.status === "CANCELLED" ||
      tab.appointmentData?.fetchError === "not_found")
      ? "danger"
      : null
  );

  // Log Redux tabs for debugging
  useEffect(() => {
    console.log("Tabs:", tabs);
  }, [tabs]);

  // Refresh the active view-appointment tab when it is clicked/activated
  useEffect(() => {
    const active = tabs[activeTab];
    const apptId =
      active?.contentType === "viewAppointment"
        ? active?.appointmentData?.appointmentId
        : null;
    if (!apptId) return;

    let cancelled = false;
    const refresh = async () => {
      try {
        const fresh = await fetchAppointmentById(apptId);
        // Preserve shipment-driven stop reason if present on existing tab
        const existing = active?.appointmentData;
        if (existing?.stopReasonSource === "shipment") {
          fresh.stopReasonCode = existing.stopReasonCode;
          fresh.requestType = existing.requestType;
          fresh.isDropTrailer = existing.isDropTrailer;
          fresh.stopReasonSource = existing.stopReasonSource;
        }
        if (!cancelled && fresh?.appointmentId) {
          dispatch(updateAppointmentTab({ appointmentId: apptId, appointmentData: fresh }));
        }
      } catch (err) {
        const status = err?.response?.status;
        const contentCode = err?.response?.data?.content;
        const notFound = status === 404 || contentCode === "404";
        if (!cancelled && notFound) {
          const existing = active?.appointmentData || {};
          dispatch(
            updateAppointmentTab({
              appointmentId: apptId,
              appointmentData: {
                ...existing,
                appointmentId: existing.appointmentId || apptId,
                cancelled: true,
                fetchError: "not_found",
              },
            })
          );
        }
        console.error("Failed to refresh appointment tab", err);
      }
    };
    refresh();

    return () => {
      cancelled = true;
    };
  }, [activeTab, dispatch]);

  const handleFilter = (selectedValue) => {
    setFilter(selectedValue === "All Statuses" ? null : selectedValue);
  };

  const handleClearFilters = () => {
    setSearchQuery("");
    setFilter(null);
    setSearchTrigger((prev) => !prev);
  };

  // Default content for each tab
  const defaultTabContents = {
    "Appointments": (
      <MyAppointments
        key="Appointments"
        openSettingsTab={handleOpenSettingsTab}
        userType={userType}
      />
    ),
    "Request": <AppointmentsRequest key="Request" />,
    "Drafts": <DraftAppointment key="Drafts" />,
    "Settings": <CalenderSettings key="Settings" />,
  };



  // When clicking "Upload Document", add a new tab
  const handleCreateAppointment = (appointmentData) => {

    dispatch(addTab({
      id: `new-appointment-${Date.now()}`,
      name: "New Appointment",
      contentType: "newAppointment",
      appointmentData,
      isDynamic: true,
      createdAt: Date.now(),
    }));
  };

  const handleRemoveTab = (index) => {
    if (index < defaultTabsCount) {
      alert("Default tabs cannot be removed.");
      return;
    }
    dispatch(removeTab({ tabIndex: index }));
  };

  const handleSearch = () => {
    if (!searchQuery.trim()) return;

    const newTabId = `search-${Date.now()}`;
    dispatch(addTab({
      id: newTabId,
      name: `Search: ${searchQuery}`,
      contentType: "searchResults",
      searchQuery,
      isDynamic: true,
      createdAt: Date.now(),
    }));
    dispatch(setActiveTab({ index: tabs.length }));
  };


  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="p-fluid-1 shadow-md flex flex-col flex-1 h-full min-h-0 overflow-hidden">
      {/* Top Action/Filter Bar */}

      {/* Tab Content Area */}
      <div className="flex-1 mt-fluid-2 min-h-0 flex flex-col scrollbar-hide">
        <Tabs
          tabs={tabs.map((tab) => tab.name)}
          tabContents={tabs.map((tab) => {
            if (defaultTabContents[tab.id]) {
              return defaultTabContents[tab.id];
            }

            if (tab.contentType === "viewAppointment") {
              return (
                <AppointmentForm
                  key={tab.id}
                  appointmentData={tab.appointmentData}
                  setActiveTab={(payload) => dispatch(setActiveTab(payload))}
                  tabs={tabs}
                  userType={userType}
                  mode="readonly"
                />
              );
            }

            if (tab.contentType === "newAppointment") {
              if (!tab.appointmentData) {
                return <div key={tab.id} className="p-4 text-gray-500">Loading appointment...</div>;
              }
              return (
                <AppointmentForm
                  key={tab.id}
                  title={tab.name}
                  setActiveTab={(payload) => dispatch(setActiveTab(payload))}
                  tabs={tabs}
                  appointmentData={tab.appointmentData}
                  userType={userType}
                  mode="add"
                />
              );
            }

            if (tab.contentType === "editAppointment") {
              if (!tab.appointmentData?.appointmentId) {
                return <div key={tab.id} className="p-4 text-gray-500">Loading appointment...</div>;
              }
              return (
                <AppointmentForm
                  key={tab.id}
                  title={tab.name}
                  setActiveTab={(payload) => dispatch(setActiveTab(payload))}
                  tabs={tabs}
                  appointmentData={tab.appointmentData}
                  userType={userType}
                  mode="update"
                />
              );
            }
          })}
          activeTab={activeTab}
          onTabChange={(index) => dispatch(setActiveTab({ index }))}
          isDeletable={tabs.map((_, index) => index >= defaultTabsCount)}
          tabVariants={tabVariants}
          onRemoveTab={handleRemoveTab}
        />
      </div>
      {/* {isBulkModalOpen && (
      <BulkSelectionModal
        onClose={() => setIsBulkModalOpen(false)}
        // hook up any confirm logic here if your modal supports it
        // onConfirm={() => { ...; setIsBulkModalOpen(false); }}
      />
    )} */}

    </div>
  );
};

export default AppointmentDetails;
